import React, { useState } from 'react';
import { Text, TouchableOpacity } from 'react-native';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import styles from '../OrderRulesReport.styles';

interface ExportButtonProps {
  testID?: string;
  /** Triggers the export; the button shows "Exporting..." until the returned promise settles. */
  onExport?: () => Promise<void>;
}

const ExportButton: React.FC<ExportButtonProps> = ({ testID, onExport }) => {
  const [isExporting, setIsExporting] = useState(false);

  const handlePress = async () => {
    if (isExporting || !onExport) return;
    setIsExporting(true);
    try {
      await onExport();
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <TouchableOpacity style={styles.exportBtn} onPress={handlePress} activeOpacity={0.8} testID={testID} disabled={isExporting}>
      <MaterialIcons name={isExporting ? 'hourglass-empty' : 'file-download'} size={14} color="#4B5563" />
      <Text style={styles.exportBtnText}>{isExporting ? 'Exporting...' : 'Export'}</Text>
    </TouchableOpacity>
  );
};

export default ExportButton;
